import { render, staticRenderFns } from "./BaseActionPanel.vue?vue&type=template&id=3a0d28f6&scoped=true&"
import script from "./BaseActionPanel.vue?vue&type=script&lang=js&"
export * from "./BaseActionPanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseActionPanel.vue?vue&type=style&index=0&id=3a0d28f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0d28f6",
  null
  
)

export default component.exports